import Label from "../../../../components/Label";
import twMerge from "../../../../lib/twMerge";

export default function ConfigSection({
  className,
  title,
  children,
}: {
  className?: string;
  title: string;
  children: React.ReactNode;
}): React.ReactElement | null {
  return (
    <div className={twMerge("flex flex-col items-stretch", className)}>
      <Label type="title4" className="mb-2 text-tx-muted">
        {title}
      </Label>
      {children}
    </div>
  );
}
